import React from 'react';
import moment from 'moment';
import { IconEditCustom } from '@sfx/icons';
import { CellSubscriptionUser } from '../common/cell.component';
var LICENSE_ID = 'objectID';
var ISSUE_DATE = 'issueDate';
var EXPIRY_DATE = 'expiryDate';
var LICENSE_TYPE = 'licenseType';
var LICENSE_USER = 'User';
var defaultVal = '--';

var CellActions = function CellActions(_ref) {
  var row = _ref.row,
      handleEdit = _ref.handleEdit;
  var utcNow = moment.utc();
  var issueDate = moment(row.row[ISSUE_DATE]);
  var expiryDate = moment(row.row[EXPIRY_DATE]);
  var subscriptionNotAvailable = issueDate > utcNow;
  var subscriptionExpired = expiryDate < utcNow;
  var editAction = /*#__PURE__*/React.createElement("div", {
    className: 'cellActions'
  }, /*#__PURE__*/React.createElement("span", {
    className: "action-icon-wrap",
    onClick: function onClick() {
      return handleEdit(row);
    }
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    "option-type": "edit",
    size: 18,
    style: {
      marginRight: "13px"
    }
  })));
  return !subscriptionExpired && !subscriptionNotAvailable ? editAction : /*#__PURE__*/React.createElement(React.Fragment, null);
};

var sortMethod = function sortMethod(prev, next) {
  if (prev === next) {
    return 0;
  }

  if (!prev) {
    return -1;
  }

  if (!next) {
    return 1;
  }

  var prevFormat = moment(prev).valueOf();
  var nextFormat = moment(next).valueOf();

  if (prevFormat > nextFormat) {
    return 1;
  }

  if (prevFormat < nextFormat) {
    return -1;
  }

  return 0;
};

var timeCell = function timeCell(row) {
  var momentDate = moment(row.value);
  var formatTime = "";

  if (momentDate.isValid()) {
    formatTime = momentDate.format('YYYY-MM-DD HH:mm');
  }

  return formatTime;
};

export var columnConfig = function columnConfig(handleEdit, translate) {
  return [{
    id: LICENSE_ID,
    disableHeaderSort: true,
    accessor: function accessor(row) {
      return row[LICENSE_ID];
    },
    Header: translate('SFxAccountSettingsSubscriptionTableKeyTitle'),
    headerStyle: {
      minWidth: 300,
      paddingLeft: "10px"
    },
    style: {
      minWidth: 300,
      paddingLeft: "8px"
    },
    minWidth: 300
  }, {
    id: ISSUE_DATE,
    accessor: function accessor(row) {
      return row[ISSUE_DATE];
    },
    Header: translate('SFxAccountSettingsSubscriptionTableIssueDateTitle'),
    isFilterable: false,
    isSortable: true,
    Cell: timeCell,
    sortMethod: sortMethod,
    sortTextAsc: translate('SFxAccountSettingsSubscriptionTableDateSortTextAsc'),
    sortTextDesc: translate('SFxAccountSettingsSubscriptionTableDateSortTextDesc'),
    headerStyle: {
      minWidth: 120
    },
    style: {
      minWidth: 120
    },
    minWidth: 120
  }, {
    id: EXPIRY_DATE,
    accessor: function accessor(row) {
      return row[EXPIRY_DATE];
    },
    Header: translate('SFxAccountSettingsSubscriptionTableExpiryDateTitle'),
    isFilterable: false,
    isSortable: true,
    Cell: timeCell,
    sortTextAsc: translate('SFxAccountSettingsSubscriptionTableDateSortTextAsc'),
    sortTextDesc: translate('SFxAccountSettingsSubscriptionTableDateSortTextDesc'),
    sortMethod: sortMethod,
    headerStyle: {
      minWidth: 120
    },
    style: {
      minWidth: 120
    },
    minWidth: 120
  }, {
    id: LICENSE_TYPE,
    accessor: function accessor(row) {
      return row[LICENSE_TYPE];
    },
    Header: translate('SFxAccountSettingsSubscriptionTableTypeTitle'),
    isFilterable: false,
    isSortable: false,
    headerStyle: {
      minWidth: 80
    },
    style: {
      minWidth: 80
    },
    minWidth: 80
  }, {
    id: 'licenseTypeCell',
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsSubscriptionTableObjectTitle'),
    headerStyle: {
      minWidth: 120
    },
    style: {
      minWidth: 120
    },
    minWidth: 120,
    Cell: function Cell(_ref2) {
      var row = _ref2.row;
      var _row$_original = row._original,
          licensedUser = _row$_original.licensedUser,
          licensedAsset = _row$_original.licensedAsset;

      var user = function user() {
        return licensedUser ? /*#__PURE__*/React.createElement(CellSubscriptionUser, {
          licensedUser: licensedUser
        }) : defaultVal;
      };

      return row[LICENSE_TYPE] === LICENSE_USER ? user() : licensedAsset && licensedAsset.Name || defaultVal;
    }
  }, {
    id: "_actions",
    Header: "",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    headerStyle: {
      minWidth: 80
    },
    style: {
      minWidth: 80,
      padding: 5
    },
    minWidth: 80,
    className: "disable-resize",
    headerClassName: "disable-resize",
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellActions, {
        row: row,
        handleEdit: handleEdit
      });
    }
  }];
};